require('./sms-campaign.scss')

module.exports = {
  template: require('./sms-campaign.pug')()
  controller: require('./sms-campaign.ctrl')
}
